import { useStore, selectCreature } from '@/infra/store';
import { isLow } from '@/domain/stats/vitality';
import { PixelIcon } from '@/presentation/icons/PixelIcon';

const FONT_PIXEL = '"Courier New", monospace';

export function VitalityBar() {
  const c = useStore(selectCreature);
  if (!c) return null;
  const v = Math.max(0, Math.min(100, c.state.vitality));
  const low = isLow(v);
  const segments = 12;
  const filled = Math.round((v / 100) * segments);
  return (
    <div data-testid="vitality-bar" style={wrap}>
      <PixelIcon name="heart" size={16} color={low ? '#ff5566' : '#ff5566'} />
      <span style={{ ...label, color: low ? '#ff5566' : '#ffd6b3' }}>
        {Math.round(v).toString().padStart(3, '0')}
      </span>
      <div style={track}>
        {Array.from({ length: segments }).map((_, i) => (
          <div
            key={i}
            style={{
              flex: 1,
              height: '100%',
              background: i < filled ? (low ? '#ff5566' : '#6cf08f') : '#2a2a3e',
              borderRight: i < segments - 1 ? '1px solid #0a0a14' : 'none',
              animation: low && i < filled ? 'vitBlink 0.6s steps(2) infinite' : 'none',
            }}
          />
        ))}
      </div>
      <style>{`@keyframes vitBlink {0%,100%{opacity:1}50%{opacity:0.3}}`}</style>
    </div>
  );
}

const wrap: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  background: '#0e0e1c',
  padding: '6px 10px',
  border: '3px solid #ffd6b3',
  imageRendering: 'pixelated',
  boxShadow: '0 0 0 1px #0a0a14, 3px 3px 0 rgba(0,0,0,0.5)',
};

const label: React.CSSProperties = {
  fontFamily: FONT_PIXEL,
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: 1,
  minWidth: 56,
};

const track: React.CSSProperties = {
  display: 'flex',
  width: 130,
  height: 12,
  background: '#0a0a14',
  border: '1px solid #3a3a5e',
};
